import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { QuoteActions } from '@nibtravel/shared/data-access/quote';
import { PurchasePathAnalyticsService } from '@nibtravel/shared/data-access/gtm-analytics';
import { UnderwriterAction } from '@nibtravel/shared/data-access/underwriter';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GA4ActionHandler {
  constructor(
    private actions$: Actions,
    private _purchasePathAnalyticsService: PurchasePathAnalyticsService
  ) {}

  submitQuote$ = this.actions$
    .pipe(
      ofActionSuccessful(QuoteActions.SubmitQuote),
      tap((payload) => {
        this._purchasePathAnalyticsService.submitQuote(payload.data);
      })
    )
    .subscribe(() => {
      //console.log('submit a quote action subscribed');
    });

  emailQuote$ = this.actions$
    .pipe(
      ofActionSuccessful(QuoteActions.SendEmailQuote),
      tap((payload) => {
        this._purchasePathAnalyticsService.emailQuote(payload.data);
      })
    )
    .subscribe(() => {
      //console.log('email a quote action');
    });

  editTripModalGoogleAnalytics$ = this.actions$
    .pipe(
      ofActionSuccessful(QuoteActions.EditTripModal),
      tap(() => {
        this._purchasePathAnalyticsService.editTripEvent();
      })
    )
    .subscribe(() => {});

  updateQuoteGoogleAnalytics$ = this.actions$
    .pipe(
      ofActionSuccessful(QuoteActions.UpdateQuote),
      tap((payload) => {
        this._purchasePathAnalyticsService.updateQuoteEvent(payload.data);
      })
    )
    .subscribe(() => {});

  applyPromoCode$ = this.actions$
    .pipe(
      ofActionSuccessful(QuoteActions.ApplyPromoCode),
      tap(() => {
        this._purchasePathAnalyticsService.applyPromotionEvent();
      })
    )
    .subscribe(() => {});

  selectPlan$ = this.actions$
    .pipe(
      ofActionSuccessful(UnderwriterAction.SetCurrentContractId),
      tap((data) => {
        this._purchasePathAnalyticsService.selectPlan(data);
      })
    )
    .subscribe(() => {
      //console.log('select a plan action is called');
    });

  togglePlanDetailsAccordion$ = this.actions$
    .pipe(
      ofActionSuccessful(QuoteActions.TogglePlanDetailsAccordion),
      tap((data) => {
        this._purchasePathAnalyticsService.togglePlanDetailsAccordion(data);
      })
    )
    .subscribe(() => {
      //console.log('toggle plan details accordion action is called');
    });

  submitPayment$ = this.actions$
    .pipe(
      ofActionSuccessful(QuoteActions.Purchase),
      tap((payload) => {
        this._purchasePathAnalyticsService.submitPayment(payload.data);
      })
    )
    .subscribe(() => {
      //console.log('submit payment action');
    });
}
